import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import api from "../utils/api";
const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const baseUrl = process.env.REACT_APP_API_URL;

  const fetchCurrentUser = async () => {
    try {
      const response = await api.get(`/api/current-user`, { withCredentials: true });
      setCurrentUser(response.data);
    } catch (error) {
      setCurrentUser(null); // Not logged in
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCurrentUser();
  }, []);

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser, loading }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
